<template>
  <ul class="AddressPicker">
    <li>
      <select class="provinces" v-model="province">
        <option v-for="(item,key) in provincesName" :value="item">{{key}}</option>
      </select>
    </li>
    <li>
      <select class="citys" v-model="city">
        <option v-for="(item,key) in citysName" :value="item">{{key}}</option>
      </select>
    </li>
    <li>
      <select class="countys" v-model="county">
        <option v-for="(item,key) in countysName" :value="item">{{key}}</option>
      </select>
    </li>

  </ul>
</template>

<script>
  import {addrobj, addrname} from '../assets/addr.js'

  module.exports = {
    data: function () {
      return {
        province: 10,
        city: 29,
        county: 381,
        provinceName: '北京',
        cityName: '海淀',
        countyName: '三环到四环之间'
      }
    },
    computed: {
      provincesName: function () {
        var provinceName = {};
        for (var i in addrobj) {
          provinceName[i] = addrname[i];
        }
        return provinceName
      },
      citysName: function () {
        var cityName = {};
        for (var i in addrobj[this.province]) {
          cityName[i] = addrname[i]
        }
        return cityName
      },
      countysName: function () {
        var countyName = {};
        for (var i in addrobj[this.province][this.city]) {
          var county = addrobj[this.province][this.city][i];
          countyName[county] = addrname[county]
        }
        return countyName
      }
    },
    watch: {
      'province': function (n, o) {
        if (n != o) this.city = Object.getOwnPropertyNames(this.citysName)[0];
        this.provinceName = this.provincesName[this.province]
      },
      'city': function (n, o) {
        if (n != o) this.county = Object.getOwnPropertyNames(this.countysName)[0];
        this.cityName = this.citysName[this.city]
      },
      'county': function () {
        this.countyName = this.countysName[this.county]
      }
    }
  }
</script>
<style scoped>
  .AddressPicker {
    display: flex;
    padding: 0;
    height: 0.5rem;
    list-style: none;
    margin: 0.2rem auto;
    background: url("../assets/address.png") no-repeat;
    background-size: 4rem 0.26rem;
    background-position-y: 11px;
  }

  li {
    width: 20%;
    display: inline-block;
    font-size: 0.2rem;
    margin: 0 0 2% 12%;
  }

  .AddressPicker li:first-child {
    margin-left: 5%;
  }

  .AddressPicker li:nth-child(3) {
    width: 24%;
  }

  select {
    display: inline-block;
    width: 100%;
    height: 88%;
    padding-left: 2%;
    border: none;
    font-size: 0.2rem;
    background-color: #fdf8f5;
    -webkit-appearance: none;
  }

</style>



// WEBPACK FOOTER //
// AddressPicker.vue?b68e4f02